import styled from "styled-components";

export const GridContainer = styled.div`
  display: grid;
  height: 100vh;
  grid-template-rows: 120px 2fr 3.5fr 150px;
  grid-template-columns: 1fr 3fr auto;
  background: ${(props) =>`url(${props.backgroundImage})` || props.background};
  ${'' /* background: ${(props) => props.backgroundImage ? `url(${props.backgroundImage})` : props.background}; */}
  background-size: cover;
  background-position: center;

  
  @media (max-height: 1050px) {
    grid-template-columns: 1fr 3fr auto;
  }
  .video {
    border: 2px solid ${(props) => props.theme.borderColor};
    margin-right: -40px;
    border-radius: 10px;
  }
  @media screen and (min-device-pixel-ratio: 2), 
       screen and (-webkit-min-device-pixel-ratio: 2) {
  body {
    zoom: 0.5; 
  }
}
`;

export const StyledH5 = styled.h5`
  color: ${(props) => props.textColor}; // Access dynamic color
  font-family: ${(props) => props.fontFamily || "inherit"}; 
  font-size: ${(props) => props.fontSize || "1.5rem"}; // Default to 1.5rem if not provided

  text-align: center;
`;

export const GridCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const TopRow = styled(GridCell)`
  grid-row: 1;
  grid-column: 1 / span 3;
  background: ${(props) => props.theme.topRowBackground};
  backdrop-filter: blur(10px);
  h5 {
    color: ${(props) => props.theme.textColor};
    font-size: ${(props) => props.theme.headerFontSize || "2.3rem"};
    
    margin-top: 40px;
    font-family: ${(props) => props.theme.fontFamily};
  }
`;

export const ParentContainer = styled.div`
  display: flex;
  flex-direction: column; /* Stacks items vertically */
  align-items: center; /* Center align items horizontally */
  width: 100%;
  height: 100%;
  padding: 10px;
`;

export const TopRowLeft = styled.div`
  width: 100%; /* Full width to take up entire row */
  height: 100%;
  margin: 40px 10px 10px 10px;
`;

export const TopRowCenter = styled(GridCell)`
  grid-row: 2;
  grid-column: 2;
  margin-top: -330px;
  z-index: 12;
`;

export const TopRowRight = styled(GridCell)`
  grid-row: 2;
  grid-column: 3;
  margin: 10px;
`;


// export const MiddleLeftColumn = styled(GridCell)`
//   grid-row: 3 / span 2; 
//   grid-column: 1;
//   margin: 0px 10px 0px 0px;
//   width: 100%;
  
//   display: grid; 
//   ${'' /* grid-template-rows: 1fr 1fr;  */}
//   grid-template-rows: 2.5fr 2fr;
//   gap: 10px;
//   height: 100%;
// `;

export const MiddleLeftColumn = styled(GridCell)`
  grid-row: 3 / span 2;
  grid-column: 1;
  margin: 0px 10px 0px 0px;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MiddleCenterColumn = styled(GridCell)`
  grid-row: 2;
  grid-column: 2;
  align-self: start;
  margin: 30px 20px 0px 0px;
  max-height: calc(100vh - 150px); 
  overflow: hidden; 
`;

export const MiddleRightColumn = styled(GridCell)`
  grid-row: 2 / span 2; /* מתחיל בשורה 2 ונפרס לשורה 3 */
  grid-column: 3;
  margin: 0px;
`;

export const BottomRow = styled(GridCell)`
  grid-row: 5;
  grid-column: 1 / span 3;
`;

export const WelcomeText = styled.div`
  h1 {
    font-size: ${(props) => props.theme.welcomeFontSize || "7rem"};
    color: ${(props) => props.theme.textColor};
    text-align: center;
    margin-bottom: 20px;
    margin-left: 50px;
  }

  h5 {
    font-size: ${(props) => props.theme.subHeaderFontSize || "2rem"};
    color: ${(props) => props.theme.textColor};
    text-align: center;
    margin-top: 0;
  }
`;

export const TimeDateBar = styled.div`
  position: absolute;
  right: 0;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  color: ${(props) => props.theme.textColor};
  background: ${(props) => props.theme.timeDateBarBackground};
  font-family: ${(props) => props.theme.fontFamily};
  z-index: 10;
  grid-row: 1;
`;

export const WeatherCenter = styled.div`
  font-size: ${(props) => props.theme.weatherFontSize || "1.1rem"};
  font-family: ${(props) => props.fontFamily || "inherit"}; 
  display: flex;
  color: ${(props) => props.color || props.theme.weatherTextColor};
  justify-content: flex-end;
  gap: 10px;
  color: ${(props) => props.color || props.theme.weatherTextColor};
`;

export const TimeClock = styled.div`
  font-size: ${(props) => props.theme.clockFontSize || "2.8rem"};
  text-align: right;

  .timeDate {
    margin-top: 10px;
    font-size: ${(props) => props.theme.dateFontSize || "1.2rem"};
    text-align: right;
    display: flex; 
    align-items: center;
    justify-content: flex-end; 
    color: ${(props) => props.theme.textColor};
  }
`;

export const HebrewDateText = styled.div`
  font-size: ${(props) => props.theme.hebrewDateFontSize || "1.5rem"};
  text-align: right;
  margin-top: 0px;
  color: ${(props) => props.theme.textColor};
`;

export const StyledTimeClock = styled.div`
  font-size: 2.8rem;
  text-align: right;
  color: ${(props) => props.textColor}; // Set text color dynamically
  font-family: ${(props) => props.fontFamily || "inherit"}; // Optional dynamic font
  .timeDate {
    margin-top: 10px;
    font-size: 1.2rem;
    color: ${(props) => props.textColor}; // Ensure nested text inherits color
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const RSSWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;